import React from 'react';
import { Box, Text } from '@razorpay/blade/components';
import { getStaticMediaUrl } from 'utils/Urls';
import documentIcon from 'assets/icons/icon_document.svg';

export const PreviewMetric = ({ title, value }: { title: string; value: string }) => {
  return (
    <Box 
      borderWidth="thin"
      borderStyle="solid"
      borderColor="surface.border.gray.subtle"
      backgroundColor="surface.background.gray.moderate" 
      paddingX="spacing.6"
      paddingY="spacing.4"
      borderRadius="medium"
      display="flex"
      alignItems="center"
      justifyContent='space-between'
      gap="spacing.8"
    >
      <Box display="flex" gap="spacing.3" alignItems="center">
        <Box 
          borderWidth="thin"
          borderColor="surface.border.gray.subtle"
          borderRadius="max"
          width='spacing.8'
          height='spacing.8'
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <img src={getStaticMediaUrl(documentIcon)} alt={title} style={{ width: '12px', height: '12px' }} />
        </Box>
        <Text color="surface.text.gray.subtle" size="small">{title}</Text>
      </Box>
      <Text color="surface.text.gray.muted" size="large">{value}</Text>
    </Box>
  );
};